// @flow
export default {
  path: '/lojastim/atitudeAzul',
  meta: {
    notAuth: true
  },
  component: () => import('modules/SS360-AtitudeAzul/Index.vue')
};
